/* istanbul ignore file */
/* eslint-disable max-len */
import moment from 'moment'
import config from '../config.json'
import apiRequest from './api.request'
import { parseQueryString, appStorage, logError, asyncMemoize } from './utils'
import getSource from './get-source'
import defaultConfig from '../default-app-config'
// import userProfile from '../mocks/user-details.json';
import testCentersAddress from '../mocks/test-centers.json'
import mockUserCases from '../mocks/get-cases.json'
// import { getBasicLocationDetails } from './get-location';
import { getLocationFromStore } from './get-location'

const langForApiMap = {
  en: 'English',
  hi: 'Hindi',
  gu: 'Gujarati',
  be: 'Bengali',
  mr: 'Marathi',
  kn: 'Kannada',
  ml: 'Malayalam',
  pa: 'Punjabi',
  te: 'Telugu',
  ta: 'Tamil',
  or: 'Oriya',
  fr: 'French',
  sp: 'Spanish',
  English: 'English',
  Hindi: 'Hindi',
  Gujarati: 'Gujarati',
  Bengali: 'Bengali',
  Marathi: 'Marathi',
  Kannada: 'Kannada',
  Malayalam: 'Malayalam',
  Punjabi: 'Punjabi',
  Telugu: 'Telugu',
  Tamil: 'Tamil',
  Oriya: 'Oriya',
  French: 'French',
  Spanish: 'Spanish',
  eng: "English",
  hin: "Hindi",
  mar: "Marathi",
  ben: "Bengali",
  guj: "Gujarati",
  pan: "Punjabi",
  kan: "Kannada",
  tam: "Tamil",
  tel: "Telugu",
  mal: "Malayalam",
  ori: "Odia",
  spa: "Spanish",
  fra: "French",
}

// eslint-disable-next-line no-unused-vars
export const languageForApi = (language) => {
  if (language) {
    return langForApiMap[language] || 'English'
  }
  const storedPref = appStorage.getItem('language_name')
  if (storedPref) {
    return storedPref
  }
  return 'English'
}
export const getWorkFlow_Id = (preferAppStore = undefined) => {
  if (preferAppStore) {
    const workflow_id_appStorage = appStorage.getItem('workflow_id')
    if (workflow_id_appStorage) return workflow_id_appStorage
  }
  const params = parseQueryString()
  if (params.workflow_id) return params.workflow_id
  const storedPref = appStorage.getItem('workflow_id')
  return !storedPref ? config.covidWorkFlowID : storedPref
}

const [wrappedGetWorkFlow, clearWrapperWorkflow] = asyncMemoize(async (language, preferAppStore) => {
  try {
    const data = await apiRequest(
      `${config.baseURL + config.workFlowTemplateHost + getWorkFlow_Id(preferAppStore)
      }&language=${languageForApi(language)}`,
      {},
      false
    )

    // const data = await apiRequest(config.baseURL + config.workFlowTemplateHost + languageForApi(language), {}, false);
    if (!data.worflow_template) {
      return new Promise((resolve, reject) => {
        reject(new Error('Empty workflow response'))
      })
    }
    return new Promise((resolve) => {
      resolve(data)
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(new Error('Empty workflow response'))
    })
  }
})

export const getWorkflow = wrappedGetWorkFlow
export const clearMemoizedWorkflow = clearWrapperWorkflow

const [wrappedGetDiseaseStats] = asyncMemoize(async (region, language) => {
  const {
    data: { regional, summary },
    updated_at,
    data_source
  } = await apiRequest(
    // eslint-disable-next-line max-len
    `${config.baseURL_Information_Extractor}${region === 'india' ? config.diseaseInfoIndia : config.diseaseInfoWorld
    }${`?language=${languageForApi(language)}`}`,
    {},
    false
  )

  return {
    summary,
    updatedAt: updated_at,
    source: data_source,
    stats: regional
  }
}, 'get-workflow')

export const getDiseaseStats = wrappedGetDiseaseStats

export const getStates = (language) =>
  apiRequest(
    `${config.baseURL_CorePlatform
    }list_entity_details/?class=state&language=${languageForApi(language)}`,
    {},
    false
  )

const [wrappedGetTopoJson] = asyncMemoize(
  (region) => apiRequest(`/${region}.json`, {}, false),
  'get-topo-json'
)

export const getTopojson = wrappedGetTopoJson

export const getTestCentres = (stateId, language) =>
  apiRequest(
    // eslint-disable-next-line max-len
    `${config.baseURL_CorePlatform
    }list_entity_details/?class=healthcareestablishment&language=${languageForApi(
      language
    )}&state_id=${encodeURIComponent(stateId)}`,
    {},
    false
  )

const [wrappedGetSurveyResult] = asyncMemoize((guru_user_id) => {
  const parsed = parseQueryString()

  const queryString = [
    `source_user_id=${encodeURIComponent(parsed.source_user_id)}`,
    `source_id=${parsed.source_id}`,
    `business_id=${encodeURIComponent(parsed.business_id)}`,
    `source_relation=${parsed.source_relation}`,
    `source_user_relation_id=${parsed.source_user_relation_id}`,
    `guru_user_id=${guru_user_id}`
  ].join('&')

  return apiRequest(
    `${config.baseURLUserPlatform}/get_survey_result?${queryString}`,
    {},
    false
  )
}, 'survey-result')

export const getSurveyResult = wrappedGetSurveyResult

export const publishEvent = async (eventName, data) => {
  // publishEventInOldEnvironment(eventName, data);
  try {
    const location = getLocationFromStore()
    const {
      source_id = '',
      source_user_id = '',
      business_id = ''
    } = await getSource()
    if (parseQueryString().uid) {
      const jhh_token = appStorage.getItem("jhh_token") ? appStorage.getItem("jhh_token") : undefined
      if (jhh_token) {
        appStorage.removeItem("jhh_token")
      }
      return apiRequest(
        config.eventsHost,
        {
          event: {
            datetime: moment().format('DD/MM/YYYY hh:mm:ss A'),
            source_id,
            source_user_id,
            business_id,
            ...{ user_id: parseQueryString().uid },
            ...location,
            event_name: eventName,
            event_data: data,
            jhh_token
          }
        },
        true,
        true
      )
    }
    const jhh_token = appStorage.getItem("jhh_token") ? appStorage.getItem("jhh_token") : undefined
    if (jhh_token) {
      appStorage.removeItem("jhh_token")
    }
    return apiRequest(
      config.eventsHost,
      {
        event: {
          datetime: moment().format('DD/MM/YYYY hh:mm:ss A'),
          source_id,
          source_user_id,
          business_id,
          ...location,
          event_name: eventName,
          event_data: data,
          jhh_token
        }
      },
      true,
      true
    )
  } catch (e) {
    return Promise.resolve(e)
  }
}

export const publishEventInOldEnvironment = async (eventName, data) => {
  try {
    const location = getLocationFromStore()
    const {
      source_id = '',
      source_user_id = '',
      business_id = ''
    } = await getSource()
    if (parseQueryString().uid) {
      return apiRequest(
        config.eventsHostOldEnvironment,
        {
          event: {
            datetime: moment().format('DD/MM/YYYY hh:mm:ss A'),
            source_id,
            source_user_id,
            business_id,
            ...{ user_id: parseQueryString().uid },
            ...location,
            event_name: eventName,
            event_data: data
          }
        },
        true,
        true,
        false,
        null,
        null,
        true
      )
    }
    return apiRequest(
      config.eventsHostOldEnvironment,
      {
        event: {
          datetime: moment().format('DD/MM/YYYY hh:mm:ss A'),
          source_id,
          source_user_id,
          business_id,
          ...location,
          event_name: eventName,
          event_data: data
        }
      },
      true,
      true,
      false,
      null,
      null,
      true
    )
  } catch (e) {
    return Promise.resolve(e)
  }
}

/**
 * Publishes event by default at url config.eventsHost, can override the url by passing a value to eventUrl
 */
export const publishEventAtUrl = async (eventName, data, eventUrl) => {
  try {
    const location = getLocationFromStore()
    const {
      source_id = '',
      source_user_id = '',
      business_id = ''
    } = await getSource()
    if (parseQueryString().uid) {
      return apiRequest(
        eventUrl,
        {
          event: {
            datetime: moment().format('DD/MM/YYYY hh:mm:ss A'),
            source_id,
            source_user_id,
            business_id,
            ...location,
            event_name: eventName,
            event_data: data
          }
        },
        true,
        true
      )
    }
  } catch (e) {
    return Promise.resolve(e)
  }
}

export const computeRisk = async (workflowResponse, skip_compute_risk) => {
  if (skip_compute_risk) {
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'success' })
    })
  }
  try {
    const data = await apiRequest(
      config.baseURL + config.computeRiskHost,
      workflowResponse,
      true
    )
    if (data.apiResponse === 'failed' || data.statusCode !== 200) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'failure' })
      })
    }
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'failure' })
    })
  }
}

export const getHospitalList = async (reqData) => {
  try {
    const data = await apiRequest(
      config.covid_vacc_base_url + config.getVaccinationCenterList,
      reqData,
      true
    )
    if (data.apiResponse === 'failed' || data.statusCode !== 200) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'failure' })
      })
    }
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'failure' })
    })
  }
}

export const bookingAllowedCall = async (reqData) => {
  try {
    const data = await apiRequest(
      config.covid_vacc_base_url + config.bookingAllowed,
      reqData,
      true
    )
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }
}

const [wrappedGetAppConfig] = asyncMemoize(async () => {
  const source = await getSource()
  let { source_id } = source
  if (source_id !== 'MyJioApp') {
    source_id = 'covid19aicoe'
  }
  const url = `${config.baseURL}localisation/get_config/?app_id=${source_id}`
  const response = await apiRequest(url, {}, false)
  return response
}, 'app-config')

// eslint-disable-next-line no-return-await
export const getSupportedLanguages = async () =>
  await wrappedGetAppConfig().supported_languages

export const getAppConfiguration = async () => {
  const source = await getSource()
  const appConfigResponse = await wrappedGetAppConfig().app_config_parameters
  if (appConfigResponse) {
    return appConfigResponse
  }
  return source.source_id === 'MyJioApp'
    ? config.defaultMyJioAppConfig
    : config.defaultAppConfig
}

const [wrappedGetHealthCareCenters] = asyncMemoize(
  async (language, stateId) => {
    // eslint-disable-next-line max-len
    const url = `${config.baseURL_CorePlatform}list_entity_details/?class=healthcareestablishment&language=${language}&state_id=${stateId}`
    const response = await apiRequest(url, {}, false)
    return response
  },
  'get-healthcare-centers'
)

export const getHealthCareCenters = wrappedGetHealthCareCenters

const [wrappedGetFAQCategories] = asyncMemoize(
  (language) =>
    apiRequest(
      `${config.baseURL_CorePlatform
      }list_entity_details/?class=healthcareintent&language=${languageForApi(
        language
      )}`
    ),
  'get-faq-categories'
)

export const getFAQCategories = wrappedGetFAQCategories

const [wrappedGetFAQQuestions] = asyncMemoize(
  (language, categoryId) =>
    // eslint-disable-next-line max-len
    apiRequest(
      `${config.baseURL_CorePlatform
      }list_knowledge_details/?class=diseasefaq&language=${languageForApi(
        language
      )}&healthcareintent=${categoryId}`,
      {},
      false
    ),
  'get-faq-questions'
)

export const getFAQQuestions = wrappedGetFAQQuestions

export const getAddedFamilyMembers = (language) =>
  apiRequest(
    `${config.baseURL_CorePlatform
    }list_entity_details/?class=state&language=${languageForApi(language)}`,
    {},
    false
  )

export const getKavachActivationStatus = () =>
  apiRequest(
    `${config.baseURL_CorePlatform}list_entity_details/?class=state`,
    {},
    false
  )

const [wrappedGetConfig, wrappedClearConfig] = asyncMemoize(
  async (lang = '') => {
    // const source = await getSource();
    // eslint-disable-next-line max-len
    let configData = await apiRequest(
      `${config.baseURL}localisation/get_localisation/?app_id=${config.appId
      }&language=${languageForApi(lang)}`,
      {},
      false
    )
    if (configData.apiResponse === 'failed') {
      configData = defaultConfig
      configData.apiResponse = 'failed'
    }

    // const dummies = {
    //   FEATURE_SURAKSHA_KAVACH_ENABLED: false,
    //   FEATURE_MANDATE_PROFILE: false,
    //   FEATURE_SHOW_PROFILE: true
    // };
    // return { ...configData, ...dummies };
    return configData
  },
  'get-config'
)

export const getConfig = wrappedGetConfig
export const clearConfig = wrappedClearConfig

const [wrappedGetBookingTimeSlots] = asyncMemoize(
  () =>
    // apiRequest(`${config.baseURL_CorePlatform}list_entity_details/?class=state`, {}, false)
    // call respective url basis bookingSource
    new Promise((resolve) => {
      setTimeout(() => {
        const slots = [
          {
            slotId: 1234,
            startTime: '09:00 AM',
            endTime: '12:00 PM'
          },
          {
            slotId: 1235,
            startTime: '08:00 AM',
            endTime: '11:00 PM'
          },
          {
            slotId: 1236,
            startTime: '11:00 AM',
            endTime: '09:00 PM'
          },
          {
            slotId: 1237,
            startTime: '03:00 AM',
            endTime: '09:00 PM'
          },
          {
            slotId: 1238,
            startTime: '08:00 AM',
            endTime: '08:00 PM'
          }
        ]
        const currentDate = new Date()
        const futureDate = new Date(
          currentDate.setDate(currentDate.getDate() + 10)
        )
        const dummyData = {
          maxDate: futureDate,
          minDate: new Date(),
          timeSlots: slots
        }
        resolve(dummyData)
      }, 1500)
    }),
  'get-booking-slots'
)

export const getBookingTimeSlots = wrappedGetBookingTimeSlots

// eslint-disable-next-line no-unused-vars
const [wrappedGetUserProfile, wrappedClearUserProfile] = asyncMemoize(
  async () => {
    try {
      const data = await apiRequest(
        `${config.baseURLUserPlatform}/api/user/find_one`,
        {},
        true,
        false,
        false,
        false,
        true
      )
      if (data.statusCode === 204) {
        return new Promise((resolve) => {
          resolve({ guru_user_id: '', apiResponseCode: 'success' })
          // resolve(userProfile);
        })
      }

      if (data.apiResponse === 'failed') {
        return new Promise((resolve) => {
          resolve({ guru_user_id: '', apiResponseCode: 'failure' })
          // resolve(userProfile);
        })
      }
      return new Promise((resolve) => {
        resolve(data)
        // resolve(userProfile);
      })
    } catch (e) {
      logError(e)
      return new Promise((resolve) => {
        resolve({ guru_user_id: '', apiResponseCode: 'failure' })
        // resolve(userProfile);
      })
    }
  },
  'get-user-profile'
)

export const getUserProfile = wrappedGetUserProfile
export const clearUserProfile = wrappedClearUserProfile

const [wrappedGetUserCases] = asyncMemoize(async (guru_user_id) => {
  try {
    await apiRequest(
      `${config.baseURLUserPlatform}/api/v1/users/${guru_user_id}/cases`,
      {},
      false
    )
    return new Promise((resolve) => {
      resolve(mockUserCases)
    })
  } catch (e) {
    logError(e)
    return new Promise((resolve, reject) => {
      reject(e)
    })
  }
}, 'get-user-cases')

export const getUserCases = wrappedGetUserCases

export const initApp = (lang) =>
  Promise.all([getConfig(lang), getUserProfile()])

export const createProfile = async (params = {}) => {
  try {
    const data = await apiRequest(
      `${config.baseURLUserPlatform}/api/user`,
      params,
      true,
      false,
      false,
      false,
      true
    )
    /* eslint prefer-promise-reject-errors: ["error", {"allowEmptyReject": true}] */
    if (data.apiResponse === 'failed') {
      return new Promise((resolve, reject) => {
        reject()
      })
    }
    return new Promise((resolve) => {
      resolve(data)
    })
  } catch (e) {
    logError(e)
    return new Promise((resolve) => {
      resolve(null)
    })
  }
}

export const updateProfile = async (params = {}) => {
  try {
    const data = await apiRequest(
      `${config.baseURLUserPlatform}/api/user`,
      params,
      true,
      false,
      true
    )
    /* eslint prefer-promise-reject-errors: ["error", {"allowEmptyReject": true}] */
    if (data.apiResponse === 'failed') {
      return new Promise((resolve, reject) => {
        reject()
      })
    }
    return new Promise((resolve) => {
      resolve(data)
    })
  } catch (e) {
    logError(e)
    return new Promise((resolve, reject) => {
      reject()
    })
  }
}

export const getStatusForTeleCon = async () => {
  const details = {
    aptDate: '02 April 2020',
    aptTime: '12:00 PM - 02:00 PM'
  }
  try {
    const data = details
    return data
  } catch (e) {
    logError(e)
    return new Promise((resolve) => {
      resolve(null)
    })
  }
}

export const getStatusForTestCenter = async () => {
  const details = {
    aptId: '3477SD78G',
    aptDate: '02 April 2020',
    aptTime: '12:00 PM - 02:00 PM',
    testAddr:
      'Thane - Belapur Road, opp. Kopar Khairane Station, next to Dhirubhai Ambani Knowledge City, Navi Mumbai, Maharashtra 400710',
    name: 'Rameshwar Mishra',
    age: '56 year',
    gender: 'Male',
    risk: 'High'
  }
  try {
    const data = details
    return data
  } catch (e) {
    logError(e)
    return new Promise((resolve) => {
      resolve(null)
    })
  }
}

export const getStatusForSampleCollection = async () => {
  const details = {
    aptId: '3477SD78G',
    aptDate: '02 April 2020',
    aptTime: '12:00 PM - 02:00 PM',
    name: 'Rameshwar Mishra',
    age: '56 year',
    gender: 'Male',
    risk: 'High'
  }
  try {
    const data = details
    return data
  } catch (e) {
    logError(e)
    return new Promise((resolve) => {
      resolve(null)
    })
  }
}

export const bookAppointment = async () => {
  // try {
  //   const data = await apiRequest(`${config.baseURLUserPlatform}/api/user/`, params, true);
  //   return new Promise(resolve => {
  //     resolve(data);
  //   });
  // } catch (e) {
  //   logError(e);
  //   return new Promise(resolve => {
  //     resolve(null);
  //   });
  // }
}
export const getTestCenterAddresses = () => Promise.resolve(testCentersAddress)

export const bookTeleconAppointment = async (guru_user_id, ext_case_id) => {
  try {
    const params = { guru_user_id, ext_case_id }
    const data = await apiRequest(
      `${config.baseURLJioHealth}/book-telcon-appointment`,
      params,
      true
    )
    return new Promise((resolve) => resolve(data))
  } catch (error) {
    logError(error)
    return new Promise((resolve) => resolve(null))
  }
}

export const bookLabTest = async (params) => {
  try {
    const data = await apiRequest(
      `${config.baseURLJioHealth}/book-lab-test`,
      params,
      true
    )
    return new Promise((resolve) => resolve(data))
  } catch (error) {
    logError(error)
    return new Promise((resolve) => resolve(null))
  }
}

export const getCovid19Risk = async (guru_user_id) => {
  const params = { user_id: guru_user_id }
  try {
    const data = await apiRequest(
      `${config.baseURLUserPlatform}/get_covid_19_risk`,
      params,
      true
    )
    if (data.statusCode === 204) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'success', takeSurvey: true })
      })
    }
    if (data.apiResponse === 'failed' || data.statusCode !== 200) {
      return new Promise((resolve) => {
        resolve({ ...data, apiResponseCode: 'failure' })
      })
    }
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve) => {
      resolve({ apiResponseCode: 'failure' })
    })
  }
}

const transformCasesResponse = (resp, name) =>
  resp.cases &&
  resp.cases.length &&
  resp.cases.find(
    (userCase) => userCase.name.toLowerCase() === name.toLowerCase()
  )

export const getCaseForUser = async (user_id, name) => {
  try {
    const data = await apiRequest(
      `http://52.140.80.19/case-service/api/v1/users/${user_id}/cases`
    )
    return new Promise((resolve) =>
      resolve(transformCasesResponse(data, name))
    )
  } catch (error) {
    logError(error)
    return new Promise((resolve) => resolve(null))
  }
}

export const createUserCase = async (params = {}) => {
  try {
    const data = await apiRequest(
      `http://52.140.80.19/case-service/api/v1/users/${params.user_id}/cases`,
      params,
      true,
      false,
      false,
      true
    )
    return data
  } catch (error) {
    logError(error)
    return new Promise((resolve) => resolve(null))
  }
}

export const postEvent = async (source_user_id, source, eventName, data) => {
  try {
    // const location = getLocationFromStore();
    return apiRequest(
      'http://52.140.80.19/event-publisher-platform/api/event',
      {
        event: {
          id: '4cde78e1-ccc9-49b3-bd7d-3cd54886c6f3',
          user_id: source_user_id,
          source,
          source_user_id,
          datetime: '2020-04-23T12:06:46.430410',
          latitude: '10.20',
          longitude: '11.22',
          event_name: eventName,
          event_data: data
        }
      },
      true,
      true
    )
  } catch (e) {
    return Promise.resolve(e)
  }
}

export const postCoughCollectedSample = async (base64Data, audioFormat) => {
  try {
    // console.log("Kosh services:" + config.koshServiceBaseURL + config.koshServiceHost);
    const data = await apiRequest(
      `${config.koshServiceBaseURL}${config.koshServiceHost}`,
      {
        sample: {
          audio: {
            content: base64Data
          },
          config: {
            sample_rate_hertz: 0,
            encoding: audioFormat.split(';')[0]
          }
        },
        type: 'cough'
      },
      true,
      false
    )
    return new Promise((resolve) => resolve(data))
  } catch (e) {
    return Promise.resolve(e)
  }
}

export const raiseGAEvent = (new_Category, new_Action, new_Label) => {
  const params = parseQueryString();
  const getJourneySource = () => {
    if (params && params.source_id) {
      return params.source_id;
    }
    return "Direct";
  };
  function gtag(eventData) {
    // console.log(`analytics - ${JSON.stringify(eventData)}`);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  }
  gtag({
    event: "Selfhealthcheck", //recording only selfcheck events like avighna & symptom checker
    new_Category,
    new_Action,
    new_Label,
    journey_Source: getJourneySource(),
  });
}

export const raiseGAEventTeams = ({
  new_Category = "Teams Signed in Dashboard",
  new_Action,
  new_Label = "",
  failureReason = undefined,
  filter = undefined
}) => {
  const params = parseQueryString();
  const getJourneySource = () => {
    if (params && params.source_id) {
      return params.source_id;
    }
    return "Direct";
  };
  function gtag(eventData) {
    // console.log(`analytics - ${JSON.stringify(eventData)}`);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);
  }
  gtag({
    event: config.gaTeams,
    new_Category,
    new_Action,
    new_Label,
    failure_Reason: failureReason,
    journey_Source: getJourneySource(),
    Filter: filter
    // page_location: '/workflow',
    // page_referrer: 'https://healthhub.jio.com'
  });
};

export const raiseGAEventForVaccination = ({ new_Category, new_Action, new_Label, failureReason }) => {
  const params = parseQueryString();
  const getJourneySource = () => {
    if (params?.source_id === 'emp_xp') {
      return 'ESS'
    }
    return params?.source_id
  }
  function gtag(eventData) {
    console.log(`analytics - ${JSON.stringify(eventData)}`)
    window.dataLayer.push(eventData)
  }
  gtag({
    event: config.gaJioHealthHub,
    new_Category,
    new_Action,
    new_Label,
    failureReason,
    journey_Source: getJourneySource(),
    // page_location: '/workflow',
    // page_referrer: 'https://healthhub.jio.com'
  })
}

export const raiseGAEventForSlotFinder = ({ eventAction, eventLabel }) => {
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('event', eventAction, {
    'event_category': 'Vaccine Finder',
    'event_label': eventLabel,
    'page_location': '/vaccineFinder',
    'page_referrer': 'https://healthhub.jio.com'
  })
}

export const gaPageViewSlotFinder = () => {
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('event', 'page_view', {
    'page_title': 'Vaccine Finder',
    'page_location': '/vaccineFinder',
    'page_path': window.location.pathname,
    'page_referrer': 'https://healthhub.jio.com'
  })
}

export const calenderGATags = (new_Action, new_Label, new_General_Data) => {
  const params = parseQueryString();
  const getJourneySource = () => {
    if (params?.source_id === 'emp_xp') {
      return 'ESS'
    }
    return params?.source_id
  }
  function gtag(eventData) {
    window.dataLayer.push(eventData)
  }
  gtag({
    event: config.gaJioHealthHub,
    new_Category: 'Book Appointment',
    new_Action,
    new_Label: new_Label,
    new_General_Data: new_General_Data || 'NA',
    journey_Source: getJourneySource(),
  })
}

export const sendPageViewEvent = ({ VirtualPageTitle }) => {

  function gtag(eventData) {
    console.log(`analyticsPageView - ${JSON.stringify(eventData)}`)
    window.dataLayer.push(eventData)
  }

  gtag({
    event: config.gaPageView,
    VirtualPageTitle
  })
}